import Vue from 'vue';
import pageColor from './page-color';
import pageBackgroundColor from './page-background-color';
import pageBackgroundGradient from './page-background-gradient';

Vue.directive('pageColor', pageColor);
Vue.directive('pageBackgroundColor', pageBackgroundColor);
Vue.directive('pageBackgroundGradient', pageBackgroundGradient);
